import { NgModule } from '@angular/core';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { CustomSerializer } from './custom-route-serializer';
import { ROUTER_FEATURE_KEY } from './feature-key';
import { RouterEffects } from './router.effects';
import { RouterFacade } from './router.facade';

@NgModule({
    declarations: [],
    providers: [RouterFacade],
    imports: [
        StoreRouterConnectingModule.forRoot({
            serializer: CustomSerializer,
        }),
        StoreModule.forFeature(ROUTER_FEATURE_KEY, routerReducer),
        EffectsModule.forFeature([RouterEffects]),
    ],
})
export class RouterStoreModule {}
